var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56497 5.56503C6.9555 5.17451 7.58866 5.17451 7.97919 5.56503L34.8492 32.4351C35.2398 32.8256 35.2398 33.4588 34.8492 33.8493L33.435 35.2635C33.0445 35.654 32.4113 35.654 32.0208 35.2635L5.15076 8.39346C4.76024 8.00294 4.76023 7.36977 5.15076 6.97925L6.56497 5.56503Z",
    fill: "#152235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6963 9.52477C6.36453 11.5748 2.1267 15.5392 0 20.4771C3.14545 27.7803 10.9091 32.9541 20 32.9541C24.3842 32.9541 28.4596 31.7509 31.8573 29.6857L27.4347 25.2631C25.7887 27.3991 23.0714 28.7951 20 28.7951C14.9818 28.7951 10.9091 25.0686 10.9091 20.4771C10.9091 17.4027 12.735 14.7162 15.448 13.2764L11.6963 9.52477ZM29.0545 21.2261C29.0786 20.9793 29.0909 20.7295 29.0909 20.4771C29.0909 15.8855 25.0182 12.159 20 12.159C19.9958 12.159 19.9916 12.159 19.9875 12.159L16.1446 8.31617C17.3952 8.10847 18.6837 8 20 8C29.0909 8 36.8545 13.1738 40 20.4771C38.8917 23.0503 37.2101 25.3593 35.0991 27.2706L29.0545 21.2261ZM18.0018 15.8302C15.9756 16.5579 14.5455 18.3613 14.5455 20.4771C14.5455 23.2387 16.9818 25.4679 20 25.4679C22.1402 25.4679 23.9879 24.347 24.8817 22.7101L18.0018 15.8302Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeClosed);
export default __webpack_public_path__ + "static/media/icon_EyeClosed.588dbab2e32d8b2d3a35ea473d4527ab.svg";
export { ForwardRef as ReactComponent };